<p-toast position="top-right" key="probation">
  <ng-template let-message #message>
    <div class="flex flex-column gap-1 w-full">
      <div class="p-toast-summary">
        <i class="pi pi-info-circle"></i> Probation Notification
      </div>
      <div class="p-toast-detail">
        <p>Here's a summary of the employees still on probation:</p>
        <pp-probation-notification-body [data]="message.data" />
        <div class="flex flex-row justify-content-between mt-2">
          <p style="margin-top: 8px">Remind me:</p>
          <div class="flex flex-row gap-2">
            @if (show1Min) {
            <p-button
              severity="info"
              size="small"
              label="In 1 minute [UAT & DEV]"
              (onClick)="closeAndRemind(defaultReminders.inOneMinute)"
            ></p-button>
            }
            <p-button
              severity="info"
              size="small"
              label="In 1 hour"
              (onClick)="closeAndRemind(defaultReminders.inOneHour)"
            ></p-button>
            <p-button
              severity="info"
              size="small"
              label="Tomorrow"
              (onClick)="closeAndRemind(defaultReminders.nextDay)"
            ></p-button>
            <p-button
              severity="info"
              size="small"
              label="Next Week"
              (onClick)="closeAndRemind(defaultReminders.nextWeek)"
            ></p-button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>
